import normalizeText from '../../components/normalize_text'

const HIDDEN_CLASS = 'entity-picker-hidden'

class EntityPicker {
  constructor() {
    this.picker = document.querySelector('[data-js="entity-picker"]')
    if (!this.picker) return

    this.search = this.element('search')
    this.selectAll = this.element('select-all')
    this.selectedList = this.element('selected')
    this.othersList = this.element('others')
    this.items = Array.from(this.picker.querySelectorAll('.entity-picker-item'))
    this.names = new Map(this.items.map((item) => [item, normalizeText(item.dataset.entityName)]))

    this.bindEvents()
    this.render()
  }

  element(name) {
    return this.picker.querySelector(`[data-js="entity-picker-${name}"]`)
  }

  bindEvents() {
    this.search.addEventListener('input', () => this.render())
    this.search.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault()
    })
    this.selectAll.addEventListener('change', () => this.selectFound())
    this.element('clear').addEventListener('click', (event) => {
      event.preventDefault()
      this.clearSelection()
    })
    this.items.forEach((item) => this.checkbox(item).addEventListener('change', () => this.render()))
  }

  checkbox(item) {
    return item.querySelector('.entity-checkbox')
  }

  isSelected(item) {
    return this.checkbox(item).checked
  }

  term() {
    return normalizeText(this.search.value)
  }

  matches(item, term) {
    return this.names.get(item).includes(term)
  }

  foundItems() {
    const term = this.term()

    return this.items.filter((item) => !this.isSelected(item) && this.matches(item, term))
  }

  selectFound() {
    this.foundItems().forEach((item) => { this.checkbox(item).checked = true })
    this.render()
  }

  clearSelection() {
    this.items.forEach((item) => { this.checkbox(item).checked = false })
    this.render()
  }

  render() {
    const term = this.term()

    this.items.forEach((item) => {
      const selected = this.isSelected(item)
      const list = selected ? this.selectedList : this.othersList

      list.appendChild(item)
      item.classList.toggle(HIDDEN_CLASS, !selected && !this.matches(item, term))
    })

    this.renderCounters()
    this.renderOthersState(term)
  }

  renderCounters() {
    const selectedCount = this.items.filter((item) => this.isSelected(item)).length

    this.element('selected-count').textContent = selectedCount
    this.element('counter').textContent = `${selectedCount} ${selectedCount === 1 ? 'selecionada' : 'selecionadas'}`
  }

  renderOthersState(term) {
    const foundCount = this.foundItems().length

    this.selectAll.checked = false
    this.element('select-all-row').classList.toggle(HIDDEN_CLASS, foundCount === 0)
    this.element('select-all-label').textContent = term === ''
      ? 'Selecionar todas'
      : `Selecionar todas as encontradas (${foundCount})`
    this.element('empty').classList.toggle(HIDDEN_CLASS, term === '' || foundCount > 0)
    this.element('all-selected').classList.toggle(HIDDEN_CLASS, term !== '' || foundCount > 0)
  }
}

export default EntityPicker
